Vue.component('ack-media-card', {
  delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
  template: '#ack-media-card',
  mounted() {
    appLog.log('ack-media-card mounted')
    
    
    
  },
  props:{
    item: {
      type: Object,
      required: true
    },
    backgroundImageClass: {
      type: String
    }
    
  },
  computed: {
    //...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
    
  },
  data() {
    return {

    }
  },
  methods: {
    //...Vuex.mapActions(['sayHi', 'someAction']),
    //...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns']),
    
    
    

  },
  beforeDestroy() {
    
  },
  watch: {
    
    item: {
      handler() {
        
        
        
      },
      deep: false
    }
  }
})